import { h } from 'preact'
import formatDateInLocalTimezone from '../../utils/dateFormatting'
import Icon from '../../assets'
import classNames from 'classnames'

const DateCell = (accessor: string) => {
  return (props: any) => {
    const isScheduled = props['status'] === 'scheduled'
    const dateFromProps = props[accessor]

    if (!dateFromProps) {
      return null
    }

    let date

    try {
      date = formatDateInLocalTimezone(dateFromProps)
    } catch (e) {
      // if the date is not alredy a timestamp, convert it
      date = formatDateInLocalTimezone(new Date(dateFromProps).getTime() / 1000 | 0)
    }

    return <div className={classNames(
      'overview__table-date',
      { 'overview__table-publish-date--scheduled': isScheduled }
    )}>
      { date }
      { isScheduled && <Icon
        icon='clock'
        width={16}
        height={16}
      /> }
    </div>
  }
}

export default DateCell
